
function setSize (parent, title, text) {
  const height = $(parent).height();
  const width = $(parent).width() - 10;
  if (width > text.width()) {
    text.width(width);
  }
  text.height(height);
}

function initBusinessPhases() {
  $(document).off('mouseenter.businessPhases', '.icon-container')
             .on('mouseenter.businessPhases', '.icon-container', function() {
    if ($(window).width() < 768) return;
    const $parent = $(this);
    const $title = $parent.find('.icon-title');
    const $text = $parent.find('.icon-text');

    setSize($parent, $title, $text);
    $title.removeClass('show').addClass('hidden-text');
    $text.removeClass('hidden-text').addClass('table-centered');
  });

  $(document).off('mouseleave.businessPhases', '.icon-container')
             .on('mouseleave.businessPhases', '.icon-container', function() {
    if ($(window).width() < 768) return;
    const $parent = $(this);
    const $title = $parent.find('.icon-title');
    const $text = $parent.find('.icon-text');

    $text.removeClass('table-centered').addClass('hidden-text');
    $title.removeClass('hidden-text').addClass('show');
  });
}

function initScrollForm() {
  $(document).off('click.scrollForm', '.scroll-form-btn')
             .on('click.scrollForm', '.scroll-form-btn', function() {
    const contactForm = document.getElementById('contact_form');
    if (contactForm && !contactForm.classList.contains('in') && !contactForm.classList.contains('show')) {
      const demoButton = document.getElementById('demo-button');
      const navbar = document.querySelector('.navbar');
      const contactFormTop = document.getElementById('contact-form-top');

      const scrollTop = demoButton ? (demoButton.offsetTop -
        (navbar ? navbar.offsetHeight : 0) -
        (contactFormTop ? contactFormTop.offsetHeight : 0)) : 0;

      window.scrollTo({
        top: scrollTop,
        behavior: 'smooth'
      });
    }
  });
}

window.scrollForm = function() {
  const contactForm = $('#contact_form');
  if (!contactForm.hasClass('in') && !contactForm.hasClass('show')) {
    const demoButton = $('#demo-button');
    const navbar = $('.navbar');
    const contactFormTop = $('#contact-form-top');
    if (demoButton.length) {
      $('html, body').animate({
        scrollTop: demoButton.offset().top - (navbar.length ? navbar.height() : 0) - (contactFormTop.length ? contactFormTop.height() : 0)
      }, 500);
    }
  }
};

document.addEventListener('DOMContentLoaded', function() {
  initBusinessPhases();
  initScrollForm();
});

document.addEventListener('turbolinks:load', function() {
  initBusinessPhases();
  initScrollForm();
});
